/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from "react";
import { getEnvironment } from '@unifocus/js-utils';
import { extractDomProps } from '../../../utils/DomPropsExtractor';
import {Calendar, CalendarProps} from 'react-calendar';

/**
 * {@docCategory ReactCalendar}
 * See props at: https://git.unifocus.com/dev/react-calendar/src/branch/master/README.md
 */
export type ReactCalendarProps = Pick<CalendarProps, Exclude<keyof CalendarProps,
   'locale' |
   'showFixedNumberOfWeeks' |
   'minDetail' |
   'maxDetail'>>;

export const ReactCalendar = React.forwardRef((props: ReactCalendarProps, ref) => {

   return (
      <Calendar
         {...extractDomProps(props)}
         value={props.value}
         locale={getEnvironment().locale}
         showFixedNumberOfWeeks={true}
         minDetail={'month'}
         maxDetail={'month'}
         className={'uf-react-calendar'}
         // @ts-ignore
         ref={ref}
      />
   );
});
